module.exports = __webpack_public_path__ + "static/9126ae38.pt_title.png";